import {
    apiConstants,
    config,
    downloadBlob,
    mockResolveApiCall,
    requestOptions,
    requestTypes,
    sendRequest
} from "../../../../Utilities/Api";
import {ownLoanMockData} from "./ownLoanMockData";

class ServerOwnLoanApi {

    static getOwnItemsReadyForProcessing(ownLoanSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(ownLoanSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(config.URL + `own/loan/?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static updateOwnLoanStatuses() {
        return mockResolveApiCall(ownLoanMockData, "");
    }

    static getDropdownListsForOwnLoanSearch() {
        const isForLoanManagement = true;
        const queryParameters = new URLSearchParams({isForLoanManagement: String(isForLoanManagement)}).toString();
        return sendRequest(
            requestOptions(config.URL + `own/loan/dropdown-lists?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static updateOwnLoans(ownLoanItems: Record<string, unknown>[]) {
        return sendRequest(
            requestOptions(config.URL + `own/loan/`,
                requestTypes.PUT,
                JSON.stringify(ownLoanItems),
                apiConstants.successMessage.ownLoan.UPDATE,
            ),
        );
    }

    static getOwnLoansReport(ownLoanSearchCriteria: Record<string, unknown>) {
        const params = {
            ...ownLoanSearchCriteria,
        };
        const queryParameters = new URLSearchParams(params as Record<string, string>).toString();
        return downloadBlob(
            requestOptions(config.URL + `own/reports/loan/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            ),
        );
    }
}

export const ownLoanApi = config.environment.MODE === config.modes.SERVER ? ServerOwnLoanApi : ServerOwnLoanApi;
